import {
    ActionSpinOptions, ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimit/promo-panel/bin/interfaces/ASInterfaces";
import {BonusBuyPopUpContent} from "@nolimit/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {NineToFive} from "../NineToFive";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";
import {Label} from "@nolimit/slot-launcher/bin/gui/labels/Label";
import {NineToFiveGameData} from "../server/NineToFiveData";
import {ASMainGamePickOptions, WINTYPE} from "@nolimit/promo-panel/bin/enums/ASEnums";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {Helper} from "@nolimit/promo-panel/bin/utils/Helper";

/**
 * Created by jonas on 2023-11-01.
 */

export class NineToFivePromoPanelConfig implements PromoPanelGameConfiguration{

    constructor() {
    }



    replaceBonusBuyPopUpContent(orgContent:BonusBuyPopUpContent):PIXI.Container {
        //You can modify the orgContent to your liking, like in the simple text replace below. All params is public in orgContent, it's basically a PIXI container with som stuff in.
        //Or you can make you your own container with everything custom. You don't need to return a BonusBuyPopUpContent, it's enough with a container.
        //Use the priceString if you change the price text, it's already formatted correctly.
        const featureShouldBeUsed = false;

        if (orgContent.featureName == "GOD_MODE" ){
            //orgContent.textLabel.text = NineToFive.apiPlugin.translations.translate("This it your custom text that \nyou need to translate yourself");
            //orgContent.textLabel.position.y += 13;
            //orgContent.textLabel.text = orgContent.textLabel.text.concat(`\n${NineToFive.apiPlugin.translations.translate("Warning: 1 Spin. No Win or Max Win!")}`);
            //orgContent.textLabel.scale.set(0.8, 0.8);
            const warningText =
                new Label(NineToFive.apiPlugin.translations.translate("Warning: 1 Spin. No Win or Max Win!"), orgContent.textLabel.getStyleClone());
            const scale = Math.min(560 / warningText.width, 1);
            warningText.scale.set(scale, scale);
            warningText.anchor.set(0.5, 0.5);
            warningText.position.set(0, 420);
            orgContent.addChild(warningText);

            const godModeStillImage = orgContent.featureImage;
            const godModeSpine = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.GOD_MODE_POPUP))
            godModeSpine.state.setAnimation(0, "Loop", true);
            godModeSpine.position.copyFrom(godModeStillImage);

            orgContent.featureImage = <PIXI.Sprite>(<any>godModeSpine);
            orgContent.removeChild(godModeStillImage);
            orgContent.addChild(godModeSpine);
        }

        return orgContent;
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Nine To Five",
            hasActionSpin: true,
            mainGame: {
                header: ()=>"xBET",
                options: [
                    {name:"NORMAL", id:0, image:"NORMAL.png"},
                    {name:"BOOSTED_BET" ,id:1, image:"BOOSTED_BET.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: "resources/images/Intro_BG.jpg"},
            getParsedData: (response: NineToFiveGameData, bet: number, prevResponse: NineToFiveGameData):ASWinData => {
                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: response.mode == GameMode.NORMAL && response.nextMode != GameMode.NORMAL,
                    totalSpinWinnings: this.getWinSize(response), //response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response), //response.nextMode == GameMode.NORMAL,
                    isBonusEnd: response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL,
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    private getWinSize(response:NineToFiveGameData) {
        return response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL
               ? response.betWayWins.map((win) => win.multipliedAmount).reduce((a,b) => a+b, 0)
               : response.totalSpinWinnings;
    }

    private getFeatureName(response: NineToFiveGameData): string {
        if ((response.mode == GameMode.FREESPIN) || response.nextMode == GameMode.FREESPIN){
            return "MIDDLE MANAGEMENT SPINS";
        }

        if ((response.mode == GameMode.FREESPIN_SUPER) || response.nextMode == GameMode.FREESPIN_SUPER){
            return "IVORY TOWER SPINS";
        }


        return response.mode;
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN)
            NineToFive.soundPlayer.playSound("asWin");
        else if (trigger == ActionSpinSound.BIG_WIN)
            NineToFive.soundPlayer.playSound("asBigWin");
    }

    private isBigWin(response:NineToFiveGameData): boolean {
        let win = response.totalSpinWinnings;

        if (response.wasFeatureBuy){
            const betPrice = NineToFive.getBetPrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private isRoundComplete(response: NineToFiveGameData): boolean {
        return  ([GameMode.FREESPIN,GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    //public getActionSpinOptions(): ActionSpinOptions {
    //    return {
    //        gameName: "Tombstone Rip",
    //        hasActionSpin: true,
    //        mainGame: {
    //            header: ()=>"xBET",
    //            options: [
    //                {name:"NORMAL", id:0, image:"NORMAL.png"},
    //                {name:"BOOSTED_BET" ,id:1, image:"BOOSTED_BET.png"}
    //            ],
    //            type: ASMainGamePickOptions.BOOSTED_BET
    //        },
    //        graphics: {backgroundTextureName: "introBg"},
    //        getParsedData: (response: ITombstoneRipGameData, bet: number, prevResponse: ITombstoneRipGameData):ASWinData => {
    //            const parsedData: ASWinData = {
    //                totalWin: response.accumulatedRoundWin,
    //                wasFeatureBuy: response.wasFeatureBuy,
    //                freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
    //                totalSpinWinnings: +response.totalSpinWinnings,
    //                isBigWin: this.isBigWin(response),
    //                winType: WINTYPE.NORMAL,
    //                featureName: this.getFeatureName(response),
    //                isRoundComplete: this.isRoundComplete(response),
    //                isBonusEnd: this.isBonusEnd(response),
    //                isWinCapHit: response.brokeTheBank,
    //            }
    //            return parsedData;
    //        }
    //    };
    //}

    //private isFreeSpinTriggered(response: ITombstoneRipGameData): boolean {
    //    return response.freespinTriggeredThisSpin === true; //(response.mode === TombstoneRipGameMode.NORMAL) && response.nextMode === TombstoneRipGameMode.FR//EESPIN;
    //}

    //private isBigWin(response:ITombstoneRipGameData): boolean {
    //    let win = response.totalSpinWinnings;

    //    if (response.wasFeatureBuy){
    //        const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice();
    //        let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
    //        return winRatio >= 1;
    //    }

    //    let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
    //    return winRatio >= 15;
    //}
}